function NotificationsMgmt() {
    return ('NotificationsMgmt');
}

export default NotificationsMgmt;
